import metadata from "./CreateAccountLandingPage.metadata.json5";
import messages from "./CreateAccountLandingPage.messages";
import styles from "./CreateAccountLandingPage.module.scss";
import { useCallback, useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { renderContentFromMetadata } from "@jutro/uiconfig";
import { withAuthenticationContext } from "gw-digital-auth-react";
import LoginPageHeaderComponent from "../../components/LoginPageHeaderComponent/LoginPageHeaderComponent";
import CustomStickyFlyouts from "../../components/CustomStickyFlyouts/CustomStickyFlyouts";
import CustomFooterComponent from "../../components/CustomFooterComponent/CustomFooterComponent";
import { CustomIconUtil } from "gw-portals-util-js";
import { TranslatorContext } from "@jutro/locale";
import CreateAccountFormComponent from "../../components/CreateAccountFormComponent/CreateAccountFormComponent";
import CreateAccountFAQ from '../../components/CreateAccountFAQ/CreateAccountFAQ';


function CreateAccountLandingPage(props) {
    const translator = useContext(TranslatorContext);
    const [currentStep, setCurrentStep] = useState('home');
          
    
    useEffect(() => {
        document.title = "Create Account - American Modern Insurance Group";
    });

    const currentStepCallback = useCallback((curStep) => {
        setCurrentStep(curStep);
    }, [currentStep]);

    const overrides = {
        mainContainer: {
            className: "create-account-landing-main-container"
        },
        createAccountLandingPageContainer: {
            className: "create-account-landing-page-container"
        },
        createAccountLayout: {
            className: "create-account-layout"
        },
        createAccountFormComponent: {
            currentStep: currentStep,
            currentStepCallback : currentStepCallback
        },
        policyholderImageContainer: {
            visible: ['enterMail', 'inviteMail'].includes(currentStep)
        },
        policyHolderMainImage: {
            className: "policy-holder-main-image",
            src: CustomIconUtil.getLogoSrc("account-main-image.png")
        },
        createAccountMenuOuterContainer: {
            visible: ['home', 'individual', 'business'].includes(currentStep),
            className: "create-account-menu-outer-container"
        },
        managePoliciesTileOuter: {
            className: "create-account-tile-outer"
        },
        managePoliciesTile: {
            className: "create-account-tile"
        },
        managePoliciesTileMediaContainer: {
            className: "create-account-tile-media-content manage-policies-tile-media-container"
        },
        managePoliciesImage: {
            className: "manage-policies-main-image",
            src: CustomIconUtil.getLogoSrc("manage-policies.png")
        },
        managePoliciesTileTextContainer:{
            className: "create-account-tile-text-content",
            content: translator(messages.managePoliciesTileText)
        },
        payBillsTileOuter: {
            className: "create-account-tile-outer"
        },        
        payBillsTile: {
            className: "create-account-tile"
        },
        payBillsTileMediaContainer: {
            className: "create-account-tile-media-content pay-bills-tile-media-container"
        },       
        payBillsImage: {
            className: "pay-bills-main-image",
            src: CustomIconUtil.getLogoSrc("pay-bills.png")
        },
        payBillsTileTextContainer:{
            className: "create-account-tile-text-content",
            content: translator(messages.payBillsTileText)
        },
        fileAndTrackTileOuter: {
            className: "create-account-tile-outer"
        },        
        fileAndTrackTile: {
            className: "create-account-tile"
        },
        fileAndTrackTileMediaContainer: {
            className: "create-account-tile-media-content file-and-track-tile-media-container"
        },
        fileAndTrackTileTextContainer: {
            className: "create-account-tile-text-content",
            content: translator(messages.fileAndTrackTileText)
        },
        fileAndTrackImage: {
            className: "file-and-track-main-image",
            src: CustomIconUtil.getLogoSrc("file-and-track.png")
        },
        createAccountFAQLayout: {
            className: 'create-account-faq-layout'
        },
    
    };

     const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            loginPageHeaderComponent: LoginPageHeaderComponent,
            createAccountFormComponent: CreateAccountFormComponent,
            customStickyFlyouts: CustomStickyFlyouts,
            customFooterComponent: CustomFooterComponent,
            createAccountFAQ: CreateAccountFAQ 
        }
    };

     const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrides,
        resolvers
    );

    return renderedContentFromMetadata;
}

export default withAuthenticationContext(withRouter(CreateAccountLandingPage));